import React, { useEffect, useState } from "react";
import { getMedicalHistorySummary } from "../Helpers/API/ReportsApi/ReportsApi";
import { formatDateWithTime } from "../Helpers/Utilities/Common";
import { Table } from "antd";
import { useParams } from "react-router-dom";

export default function MedicalHistorySummary({
  isVisible,
  setIsSelected,
  setIsMedicalHistory,
  setSelectedItem,
}) {
  const { id } = useParams();
  const [showLoader, setShowLoader] = useState(false);
  const [summary, setSummary] = useState([]);

  const handleRowClick = (record) => {
    setIsMedicalHistory(false); 
     if (record.name === "Family Past Medical History Profile") {
      setIsSelected("Family Past Medical History");
      setSelectedItem(0);
    } else if (record.name === "Heredofamilial Disease Profile") {
      setIsSelected("Family Past Medical History");
      setSelectedItem(1);
    } else if (record.name === "Hypertension Profile") {
      setIsSelected("Hypertension");
      setSelectedItem(3);
    } else if (record.name === "Diabetes Profile") {
      setIsSelected("Diabetes");
      setSelectedItem(4);
    } else if (record.name === "Thyroid Disorders Profile") {
      setIsSelected("Thyroid Disorders");
      setSelectedItem(5);
    } else if (record.name === "GDM Profile") {
      setIsSelected("GDM");
      setSelectedItem(6);
    } else if (record.name === "Pre-GDM Profile") {
      setIsSelected("Pre-GDM");
      setSelectedItem(7);
    } else if (record.name === "Pituitary Disorders Profile") {
      setIsSelected("Pituitary Disorders");
      setSelectedItem(8);
    } else if (record.name === "Other Endocrine Profile") {
      setIsSelected("Other Endocrine");
      setSelectedItem(9);
    } else if (record.name === "Asthma Profile") {
      setIsSelected("Bronchial Asthma");
      setSelectedItem(10);
    } else if (record.name === "Other Illness Profile") {
      setIsSelected("Other Illness");
      setSelectedItem(11);
    } else if (record.name === "Medication Profile") {
      setIsSelected("Maintenance Medication");
      setSelectedItem(12);
    } else if (record.name === "Allergy Profile") {
      setIsSelected("Food/Drug Allergy");
      setSelectedItem(13);
    } else if (record.name === "Smoking Profile") {
      setIsSelected("Smoking");
      setSelectedItem(14);
    } else if (record.name === "Drinking Profile") {
      setIsSelected("Drinking");
      setSelectedItem(15);
    } else if (record.name === "Illicit Drug Use Profile") {
      setIsSelected("Illicit Drug Use");
      setSelectedItem(16);
    } else if (record.name === "Herbal Use Profile") {
      setIsSelected("Herbal Use");
      setSelectedItem(17);
    } else if (record.name === "Hospitalization Profile") {
      setIsSelected("Last Hospitalization");
      setSelectedItem(18);
    } else if (record.name === "Vaccination Profile") {
      setIsSelected("Vaccination");
      setSelectedItem(19);
    } else if (record.name === "Cancer Profile") {
      setIsSelected("Cancer");
      setSelectedItem(20);
    } else if (record.name === "Family Cancer Profile") {
      setIsSelected("Family Cancer Profile");
      setSelectedItem(21);
    } else if (record.name === "Hepatitis Profile") {
      setIsSelected("Hepatitis");
      setSelectedItem(22);
    } else if (record.name === "Family Hepatitis Profile") {
      setIsSelected("Family Hepatitis Profile");
      setSelectedItem(23);
    } else if (record.name === "Pulmonary Tuberculosis Profile") {
      setIsSelected("Pulmonary Tuberculosis");
      setSelectedItem(24);
    } else if (record.name === "Family Pulmonary Tuberculosis Profile") {
      setIsSelected("Family Pulmonary Tuberculosis Profile");
      setSelectedItem(25);
    } else if (record.name === "Extrapulmonary Tuberculosis Profile") {
      setIsSelected("Extrapulmonary Tuberculosis");
      setSelectedItem(26);
    } else if (record.name === "Family Extrapulmonary Tuberculosis Profile") {
      setIsSelected("Family Extrapulmonary Tuberculosis Profile");
      setSelectedItem(27);
    } else if (record.name === "OB-Gyne History") {
      setIsSelected("OB-Gyne History");
      setSelectedItem(2);
    }
  };

  async function get() {
    setShowLoader(true);
    const res = await getMedicalHistorySummary(id);

    if (res.data) {
      var _parsed = res.data.data.map((med) => {
        return {
          ...med,
          added_on: formatDateWithTime(med.added_on),
        };
      });
      setSummary(_parsed);
    } else if (res.error) {
      setSummary([]);
    }
    setShowLoader(false);
  }
  useEffect(() => {
    get();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <Table
      columns={[
        { title: "Medical", dataIndex: "name" },
        { title: "Latest Date", dataIndex: "added_on" },
      ]}
      onRow={(record) => ({
        onClick: () => handleRowClick(record),
      })}
      dataSource={summary}
      size="small"
      loading={showLoader}
    />
  );
}
